var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5932,
    cy: 12.0004,
    r: 11.8803,
    fill: "#FD3434"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6094 14.2275L12.6094 6.80236L12.6094 14.2275Z",
    fill: "#FD3434"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6094 14.2275L12.6094 6.80236",
    stroke: "white",
    strokeWidth: 1.48503,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6094 17.1983L12.5945 17.2148L12.6094 17.1983Z",
    fill: "#FD3434"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6094 17.1983L12.5945 17.2148",
    stroke: "white",
    strokeWidth: 1.48503,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.76ca279830e1527d57f5a0a958f2066e.svg";
export { ForwardRef as ReactComponent };